import { ErrorMessage } from './error-message';

/** API hívásból visszakapott válasz kötelező része. */
export class CustomResponse {
    /** Szerver által visszaküldött üzenetlista */
    errorMessages?: ErrorMessage[];

    /** Sikeres volt-e végrehajtás */
    success?: boolean;
}
